<template>
  <div class="inner-border">
    <slot />
  </div>
</template>

<script lang="ts">
export default {
  // inheritAttrs: false
};
</script>
